<template>
  <div>
    <Card size="small">
      <a-row>
        <a-col :span="14">
          <a-radio-group defaultValue="Amazon" size="small" buttonStyle="solid" @change="providerSelected">
            <a-radio-button value="Amazon">Amazon</a-radio-button>
            <a-radio-button value="Netflix">Netflix</a-radio-button>
            <a-radio-button value="Maxdome">Maxdome</a-radio-button>
            <a-radio-button value="Magenta TV">Magenta TV</a-radio-button>
            <a-radio-button value="Joyn">joyn</a-radio-button>
            <a-radio-button value="Sky Ticket">Sky Ticket</a-radio-button>
            <a-radio-button value="TV NOW">TV NOW</a-radio-button>
            <a-radio-button value="Disney+">Disney+</a-radio-button>
            <a-radio-button value="Apple TV+">Apple TV+</a-radio-button>
            <a-radio-button value="iTunes Video">iTunes Video</a-radio-button>
          </a-radio-group>
        </a-col>
        <a-col :span="6">
          <a-button-group>
            <a-button type="primary" size="small" @click="decreaseDate">&larr;</a-button>
            <DatePicker @change="dateChanged" class="date-picker" :value="moment(selectedDate, dateFormat)" :format="dateFormat" size="small" />
            <a-button type="primary" size="small" @click="increaseDate">&rarr;</a-button>
          </a-button-group>
        </a-col>
        <a-col :span="4">
          <a-input-search
                  placeholder="search VoD Data"
                  @search="onSearch"
                  size="small"
                  enterButton
          />
        </a-col>
      </a-row>
    </Card>
  </div>
</template>

<script>
import moment from 'moment';
import { DatePicker, List, Button, Card, Row, Col, Radio, Input, Tag, Divider } from 'ant-design-vue'

export default {
  name: 'ProviderSelection',
  components: {
    DatePicker,
    List,
    Button,
    Card,
    Row,
    Col,
    Radio,
    Input,
    Tag,
    Divider
  },
  data () {
    return {
      selectedProvider: 'Amazon',
      selectedStage: 'matched',
      selectedDate: new Date().toJSON().slice(0, 10).replace(/-/g, '_'),
      dateFormat: 'YYYY_MM_DD',
    }
  },
  methods: {
    moment,
    providerSelected (event) {
      // console.log('selected', event.target.value)
      // this.selectedProvider = event.target.value
      // this.fetchData()
      this.$emit('providerSelected', event.target.value);
    },
    dateChanged (event) {
      // console.log('selected', event)
      this.selectedDate = event.format().split('T')[0]
      // this.fetchData()
      this.$emit('dateChanged', this.selectedDate);
    },
    onSearch (event) {
      this.$emit('onSearch', event);
    },
    increaseDate (event) {
      console.log('inc date')
      this.selectedDate = moment(this.selectedDate, this.dateFormat).add(1, 'days').format(this.dateFormat)
      console.log('setting Date to', this.selectedDate)
      this.$emit('dateChanged', this.selectedDate);
    },
    decreaseDate (event) {
      console.log('dec date')
      this.selectedDate = moment(this.selectedDate, this.dateFormat).add(-1, 'days').format(this.dateFormat)
      console.log('setting Date to', this.selectedDate)
      this.$emit('dateChanged', this.selectedDate);
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProviderSelection.vue